import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SIBS from './pages/SIBS/SIBS';
import Moloni from './pages/Moloni/Moloni';
import NotFound from './pages/NotFound/NotFound';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/sibs/payment-success" element={<SIBS />} />
        <Route path="/moloni/payment-success" element={<Moloni />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;